import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CmsComponentGrid from '../../components/CmsComponentGrid';
import { COLUMN_LAYOUT } from '../../constants/cmsResourceTypes';
const ColumnLayout = props => (_jsx("div", { className: "container-fluid", children: _jsx(CmsComponentGrid, Object.assign({}, props)) }));
ColumnLayout.resourceType = COLUMN_LAYOUT;
export default ColumnLayout;
//# sourceMappingURL=index.js.map